import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledDropdown,
} from "reactstrap";
import FontAwesomeIcon from "../../helpers/fontawesome/fontAwesome";
import { faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import ButtonIconTooltip from "./ButtonIconTooltip";

const PropertyListItem = ({
  name,
  propertyId,
  phone,
  onEdit,
  onDelete,
  onNotifyCredentials,
  onLinkOwner,
  onVoidInitialDebt,
  hasInitialDebt,
  username,
  alternativeName,
  property,
  balance,
  netBalance,
  debt,
  aliquot,
}) => {
  const history = useHistory();
  const [collapseOne, collapseOneOpen] = useState(false);
  // Un inmueble con solo espacios es lo mismo que uno vacío: no identifica
  // nada.
  const hasProperty = Boolean(String(property ?? "").trim());

  const handleDelete = () => {
    collapseOneOpen(false);
    onDelete();
  };

  const handleModal = () => (
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Eliminar {alternativeName}</ModalHeader>
      <ModalBody>
        <p className="mb-0 font-weight-bold fs--1">
          ¿Está seguro de eliminar el {alternativeName} {name}?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => collapseOneOpen(!collapseOne)}>Cancelar</Button>
        <Button
          data-testid="delete-button"
          color="danger"
          onClick={handleDelete}
        >
          Eliminar
        </Button>
      </ModalFooter>
    </Modal>
  );

  return (
    <>
      <tr>
        <td className="align-middle">
          <div className="d-flex flex-column flex-md-row">
            <div
              className="font-weight-bold text-dark mb-1 mb-md-0 mr-sm-2"
              style={{ minWidth: "60px" }}
            >
              {username}
            </div>
            <div className="flex-1" style={{ wordBreak: "break-word" }}>
              <div className="font-weight-semi-bold text-dark fs--1 mb-0">
                {name}
              </div>
              {/* HO-ISSUE-120: la etiqueta solo salía con el inmueble
              cargado, así que una unidad sin él se veía igual que cualquier
              otra y no había forma de saber a quién le faltaba. Ahora la fila
              lo dice, en ámbar, porque sin inmueble el propietario no se
              distingue al asignarle gastos. */}
              <div
                className={`px-2 rounded-capsule fs--2 ${
                  hasProperty
                    ? "bg-soft-primary text-primary"
                    : "bg-soft-warning text-warning"
                }`}
                style={{ display: "inline-block", maxWidth: "100%" }}
              >
                <span className="font-weight-bold mr-1">Inmueble:</span>
                {hasProperty ? property : "sin asignar"}
              </div>
            </div>
          </div>
        </td>
        <td className="align-middle">{phone || "Télefono no registrado"}</td>
        <td className="text-center align-middle">
          <div className="d-flex flex-column align-items-center">
            <div
              className={`font-weight-bold fs--1 ${
                parseFloat(netBalance || 0) < 0 ? "text-danger" : "text-success"
              }`}
            >
              {parseFloat(netBalance || 0) < 0 ? "Deuda: " : ""}$
              {Math.abs(parseFloat(netBalance || 0)).toFixed(2)}
            </div>
            {(parseFloat(balance || 0) > 0 || parseFloat(debt || 0) > 0) && (
              <div
                className="d-flex flex-column align-items-center mt-1"
                style={{ width: "100%", gap: '2px', minWidth: '130px' }}
              >
                {parseFloat(balance || 0) > 0 && (
                  <span className="badge badge-soft-success w-100 py-1" style={{ fontSize: '0.6rem' }}>
                    <FontAwesomeIcon icon="wallet" className="mr-1" />
                    A favor: ${parseFloat(balance || 0).toFixed(2)}
                  </span>
                )}
                {parseFloat(debt || 0) > 0 && (
                  <span className="badge badge-soft-danger w-100 py-1" style={{ fontSize: '0.6rem' }}>
                    <FontAwesomeIcon icon="file-invoice-dollar" className="mr-1" />
                    Deudas: ${parseFloat(debt || 0).toFixed(2)}
                  </span>
                )}
              </div>
            )}
          </div>
        </td>
        <td className="text-center align-middle">
          {parseFloat(aliquot || 0).toFixed(4)}%
        </td>
        <td className="text-center align-middle">
          <ButtonIconTooltip
            icon={faMoneyBillWave}
            color="success"
            size="sm"
            id="refresh"
            placement="top"
            onClick={() =>
              history.push(`/dashboard/properties/advance/${propertyId}`)
            }
          >
            Registrar Saldo
          </ButtonIconTooltip>
        </td>
        <td className="text-center align-middle">
          <UncontrolledDropdown direction="left">
            <DropdownToggle color="falcon-default" size="sm">
              <FontAwesomeIcon icon="ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={onEdit}>Ver detalles</DropdownItem>
              {/*   <DropdownItem onClick={onEdit}>Editar</DropdownItem> */}
              <DropdownItem
                onClick={() =>
                  history.push(`/dashboard/properties/edit/${propertyId}`)
                }
              >
                Editar
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  history.push(`/dashboard/properties/${propertyId}/visitors`, {
                    id: propertyId,
                  })
                }
              >
                Ver visitas / autorizados
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  history.push(`/dashboard/properties/advance/${propertyId}`)
                }
              >
                Registrar Saldo
              </DropdownItem>
              {hasInitialDebt && onVoidInitialDebt && (
                <DropdownItem className="text-danger" onClick={onVoidInitialDebt}>
                  Anular deuda inicial
                </DropdownItem>
              )}
              <DropdownItem onClick={onNotifyCredentials}>
                Notificar acceso por correo
              </DropdownItem>
              <DropdownItem onClick={onLinkOwner}>
                Vincular a propietario existente
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
        {handleModal()}
      </tr>
    </>
  );
};

export default PropertyListItem;
